// @ts-nocheck
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import axios from 'axios';

interface PriorityReferenceTableProps {
  formValues: any;
  intl: any;
  currentAssignmentId?: string; // for Edit screen – highlight current row
}

const PriorityReferenceTable = ({ formValues, intl, currentAssignmentId }: PriorityReferenceTableProps) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<any[]>([]);
  const [fetched, setFetched] = useState(false);

  const passengers_groups_id = formValues?.passengers_groups_id;
  const isAr = localStorage.getItem('EASY_MOBILITY_LANGUAGE') === 'ar-eg';

  useEffect(() => {
    setVisible(false);
    setFetched(false);
    setRows([]);
  }, [passengers_groups_id]);

  const fetchPriorities = async () => {
    if (!passengers_groups_id) return;
    setLoading(true);
    try {
      let authData: any = null;
      const localAuthData = localStorage.getItem('authData');
      if (localAuthData) {
        const parsed = JSON.parse(localAuthData);
        authData = parsed.userToken;
      }

      let url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_media_policy_capping_statistics/discount-band-priorities?passengers_groups_id=${passengers_groups_id}`;
      // No exclusion — we show all including current so admin can see context

      const res = await axios.get(url, {
        headers: {
          'access-token': authData?.['access-token'] || authData?.access_token,
          'uid': authData?.uid,
          'client': authData?.client,
          'Authorization': `Bearer ${localStorage.getItem('dashboard_token')}`
        }
      });
      setRows(res.data.data || []);
      setFetched(true);
    } catch (err) {
      console.error('Failed to fetch priorities', err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = () => {
    const next = !visible;
    setVisible(next);
    if (next && !fetched) fetchPriorities();
  };

  if (!passengers_groups_id) {
    return (
      <div style={{ marginTop: '6px' }}>
        <button
          type="button"
          disabled
          style={{
            fontSize: '0.78rem',
            padding: '3px 10px',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            background: '#f5f5f5',
            color: '#b8b8b8',
            cursor: 'not-allowed',
          }}
          title={intl?.formatMessage({ id: 'SelectGroupFirst' }) || "Please select a Passengers Group first"}
        >
          {intl?.formatMessage({ id: 'ViewPriorityReference' }) || 'View Priority Reference'}
        </button>
      </div>
    );
  }

  const btnLabel = visible
    ? (intl?.formatMessage({ id: 'HidePriorityReference' }) || 'Hide Priority Reference')
    : (intl?.formatMessage({ id: 'ViewPriorityReference' }) || 'View Priority Reference');

  return (
    <div style={{ marginTop: '6px' }}>
      <button
        type="button"
        onClick={handleToggle}
        style={{
          fontSize: '0.78rem',
          padding: '3px 10px',
          border: '1px solid #1890ff',
          borderRadius: '4px',
          background: visible ? '#1890ff' : '#fff',
          color: visible ? '#fff' : '#1890ff',
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
      >
        {btnLabel}
      </button>

      {visible && (
        <div style={{ marginTop: '8px', border: '1px solid #d9d9d9', borderRadius: '4px', overflow: 'hidden', fontSize: '0.82rem' }}>
          {loading ? (
            <div style={{ padding: '10px', color: '#888' }}>{intl?.formatMessage({ id: 'Loading' }) || 'Loading...'}</div>
          ) : rows.length === 0 ? (
            <div style={{ padding: '10px', color: '#888' }}>{intl?.formatMessage({ id: 'NoPriorityAssignmentsFound' }) || 'No other assignments found for this group.'}</div>
          ) : (
            <>
              <style>
                {`
                  .priority-ref-scroll::-webkit-scrollbar {
                    height: 6px;
                  }
                  .priority-ref-scroll::-webkit-scrollbar-track {
                    background: #f1f1f1;
                  }
                  .priority-ref-scroll::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 4px;
                  }
                  .priority-ref-scroll::-webkit-scrollbar-thumb:hover {
                    background: #a8a8a8;
                  }
                `}
              </style>
              <div className="priority-ref-scroll" style={{ overflowX: 'auto' }}>
                <table style={{ width: 'auto', borderCollapse: 'collapse', minWidth: '280px', maxWidth: '480px' }}>
                  <colgroup>
                    <col style={{ width: '200px' }} />
                    <col style={{ width: '80px' }} />
                    <col style={{ width: '70px' }} />
                  </colgroup>
                  <thead>
                <tr style={{ backgroundColor: '#f0f5ff', borderBottom: '1px solid #d6e4ff' }}>
                  <th style={{ padding: '6px 10px', textAlign: isAr ? 'right' : 'left', color: '#1a237e', fontWeight: 600 }}>
                    {intl?.formatMessage({ id: 'DiscountBand' }) || 'Discount Band'}
                  </th>
                  <th style={{ padding: '6px 10px', textAlign: 'center', color: '#1a237e', fontWeight: 600 }}>
                    {intl?.formatMessage({ id: 'Priority' }) || 'Priority'}
                  </th>
                  <th style={{ padding: '6px 10px', textAlign: 'center', color: '#1a237e', fontWeight: 600 }}>
                    {intl?.formatMessage({ id: 'Actions' }) || 'Actions'}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row: any, idx: number) => {
                    const isCurrent = currentAssignmentId && row.discount_band_assignments_id === currentAssignmentId;
                    return (
                      <tr 
                        key={row.discount_band_assignments_id} 
                        style={{ 
                          backgroundColor: isCurrent ? '#e6f7ff' : (idx % 2 === 0 ? '#fff' : '#fafafa'),
                          borderBottom: isCurrent ? '1px solid #91d5ff' : '1px solid #f0f0f0',
                          fontWeight: isCurrent ? 600 : 'normal',
                        }}
                      >
                        <td style={{ padding: '6px 10px' }}>
                          {isAr
                            ? (row.discount_band_en_name || row.discount_band_name)
                            : (row.discount_band_name || row.discount_band_en_name)}
                          {isCurrent && (
                            <span style={{ marginLeft: '6px', fontSize: '0.7rem', padding: '1px 5px', backgroundColor: '#1890ff', color: '#fff', borderRadius: '10px' }}>
                              {intl?.formatMessage({ id: 'CurrentRecord' }) || 'Current'}
                            </span>
                          )}
                        </td>
                        <td style={{ padding: '6px 10px', textAlign: 'center', fontWeight: 'bold', color: isCurrent ? '#1890ff' : '#595959' }}>
                          {row.priority}
                        </td>
                        <td style={{ padding: '6px 10px', textAlign: 'center' }}>
                          {isCurrent ? (
                            <span style={{ color: '#aaa', fontSize: '0.8rem' }}>—</span>
                          ) : (
                            <a 
                              href={`/fare-products/discount-band-assignment/${row.discount_band_assignments_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1890ff', textDecoration: 'none', fontWeight: '500', fontSize: '0.8rem' }}
                            >
                              {intl?.formatMessage({ id: 'View' }) || 'View'}
                            </a>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PriorityReferenceTable;
